import { IMG } from "../data/site";
import { PageHero, Section, Overline, EnquiryForm } from "../components/site/bits";
import { Reveal, Stagger, StaggerItem } from "../components/site/motion";

const ROLES = [
  ["Mentoring", "Guide and encourage residents as they settle and set goals."],
  ["Administration", "Support our office team with day-to-day tasks and projects."],
  ["English conversation", "Help residents build confidence speaking English informally."],
  ["Community activities", "Run or support events, trips and social gatherings."],
  ["Befriending", "Offer friendship and a listening ear to reduce isolation."],
];

export default function Volunteer() {
  return (
    <>
      <PageHero overline="Volunteer" lines={["Give your time,", "change a life."]} image={IMG.volunteers}
        intro="Our volunteers are at the heart of everything we do. Whatever your skills or availability, there's a way to make a real difference." />

      <Section>
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <Overline>Ways to help</Overline>
            <Stagger className="mt-8 divide-y divide-brand-dark/10">
              {ROLES.map(([t, d], i) => (
                <StaggerItem key={t} className="flex gap-6 py-6">
                  <span className="font-mono-a text-sm text-brand-green">0{i + 1}</span>
                  <div><h3 className="font-serif text-2xl text-brand-dark">{t}</h3><p className="mt-2 text-brand-slate">{d}</p></div>
                </StaggerItem>
              ))}
            </Stagger>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal><div className="rounded-3xl border border-brand-dark/10 bg-brand-surface p-8 md:p-10">
              <h2 className="font-serif text-3xl text-brand-dark">Register your interest</h2>
              <div className="mt-8">
                <EnquiryForm kind="volunteer" testid="volunteer-form" submitLabel="Get involved" fields={[
                  { name: "name", label: "Your name", required: true, placeholder: "Full name" },
                  { name: "email", label: "Email", type: "email", required: true, placeholder: "you@email.com" },
                  { name: "phone", label: "Phone", type: "tel", placeholder: "07000 000000" },
                  { name: "role", label: "Interested in", type: "select", required: true, placeholder: "Select a role", options: ROLES.map((r) => r[0]) },
                  { name: "message", label: "Availability & skills", type: "textarea", placeholder: "Tell us a little about yourself" },
                ]} />
              </div>
            </div></Reveal>
          </div>
        </div>
      </Section>
    </>
  );
}
